module.exports = __webpack_public_path__ + "img/current_schedule_crop.d6ca67f8.png";